import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarServiceHistory from "./component";
import { setIsSsr } from "../car-service-history-info/actions";
import { updateSSRStatus } from "../../shared/meta-tags/actions";
import { setGaSource } from "../../shared/ga-source/actions";

const mapStateToProps = ({
    gaSource
}) => ({
    gaSource
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setIsSsrConnect: setIsSsr,
    updateSSRStatusConnect: updateSSRStatus,
    setGaSourceConnect: setGaSource
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CarServiceHistory);

